<template>
  <div>
    <el-header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>发票管理</el-breadcrumb-item>
        <el-breadcrumb-item>抬头管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div style="padding: 20px; background: #fff">
      <div style="padding-bottom: 10px; float: right">
        <el-button size="small" type="primary" @click="addTitleBtn"
          >新建抬头</el-button
        >
      </div>
      <el-table :data="tableData" border>
        <el-table-column
          label="序号"
          type="index"
          width="50"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="enterpriseName"
          label="公司名称"
          header-align="center"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="taxPayerCode"
          label="纳税识别码"
          header-align="center"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="date7"
          label="操作"
          header-align="center"
          align="left"
          width="100"
        >
          <template slot-scope="scope">
            <el-button @click="addTitleBtn(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="delTitleBtn(scope.row)"
              >删除</el-button
            >
            <el-button
              v-if="ifSelect"
              type="text"
              size="small"
              @click="selectAdd(scope.row)"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="padding-top: 20px">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getTitleList, getDelTitle } from '@/api/adminData/index'
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      ifSelect: this.$route.query.ifSelect || false // 是否显示选择按钮
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    getListData() {
      this.contentLoading = true
      getTitleList({
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }).then((res) => {
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        }
        this.contentLoading = false
      })
    },
    handleCurrentChange(v) {
      // 分页
      this.currentPage = v
      this.getListData()
    },
    addTitleBtn(v) {
      // 编辑
      this.$router.push({
        path: '/titleAdd',
        query: {
          guid: v.guid
        }
      })
    },
    delTitleBtn(v) {
      // 删除
      this.$confirm('确定要删除本条发票抬头吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.contentLoading = true
        getDelTitle({ guid: v.guid }).then((res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.currentPage = 1
            this.getListData()
          }
          this.contentLoading = false
        })
      })
    },
    selectAdd(v) {
      // 选择
      this.$router.push({
        path: '/invoiceAdmin',
        query: {
          guid: v.guid
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.demo-form-inline {
  background: #fff;
  padding: 20px 20px 0 20px;
  margin-bottom: 20px;
}
</style>
